import { WorkflowsContext } from "@/context/WorkflowsContext";
import React from "react";

export default function useWorkflows() {
  return React.useContext(WorkflowsContext);
}
